import SelectImageAndCropModal from './select-image-and-crop-modal'

export default {
  components: {  SelectImageAndCropModal },

  props: {
    allowCropping: {
      type: Boolean,
      required: false,
      default: true
    },
    aspectRatio: {
      type: Number,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    imageBaseUrl: {
      type: String,
      required: true
    },
    previewStyle: {
      type: String,
      required: false,
      default: 'form'
    }
  },

  data() {
    return {
      image: this.initialImage
    }
  },

  methods: {
    openModal() {
      this.$refs.modal.open()
    },

    updateImage(image) {
      this.image = image
    }
  }
}
